




function equalHeights() {
    jQuery.fn.extend({
        equalHeight: function() {
            var top = 0;
            var row = [];
            var classname = ('equalHeight' + Math.random()).replace('.', '');
            jQuery(this).each(function() {
                var thistop = jQuery(this).offset().top;
                if (thistop > top) {
                    jQuery('.' + classname).removeClass(classname);
                    top = thistop;
                }
                jQuery(this).addClass(classname);
                jQuery(this).height('auto');
                var h = (Math.max.apply(null, jQuery('.' + classname).map(function() {
                    return jQuery(this).outerHeight();
                }).get()));
                jQuery('.' + classname).height(h);
            }).removeClass(classname);
        }
    });
    jQuery('.shop-filters-wrapper .shop-filters-item .shop-filter-title').equalHeight();
    jQuery('.subscribing-benefit-section .subscribing-benefit-grid h3').equalHeight();
  }


var autoShipFlag = true;
function autoShipSlider(){
    if($('.hydroviv-auto-ship-new').length){
        if($(window).width() <= 767){
            if(autoShipFlag){
                $('.hydroviv-auto-ship-new .auto-ship-outer-wrapper .left-block').detach().insertBefore('.hydroviv-auto-ship-new .auto-ship-outer-wrapper .right-block .video-wrapper');
                setTimeout(() => {
                    $('.hydroviv-auto-ship-new .left-block-inner').on('init', function(event, slick){
                        $('.hydroviv-auto-ship-new .left-block-inner').css('height','inherit');
                        $('.hydroviv-auto-ship-new .left-block-inner').css('opacity',1);
                    });
                    $('.hydroviv-auto-ship-new .left-block-inner').slick({
                        arrows: false,
                        dots: true,
                        slidesToShow: 2,
                        centerMode: true,
                        responsive:[
                            {
                                breakpoint: 4000,
                                settings: "unslick",
                            },
                            {
                                breakpoint: 767,
                                settings: "slick",
                            },
                            {
                                breakpoint: 574,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ],
                    });
                }, 200);
                autoShipFlag = false;
            }        
        }
        else{
            if(!autoShipFlag){
                if($('.hydroviv-auto-ship-new .left-block-inner.slick-initialized').length){
                    setTimeout(() => { 
                        $('.hydroviv-auto-ship-new .left-block-inner').slick('unslick');
                    },200)                    
                }  
                $('.hydroviv-auto-ship-new .auto-ship-outer-wrapper .right-block .left-block').css('opacity',0);
                $('.hydroviv-auto-ship-new .auto-ship-outer-wrapper .right-block .left-block').detach().insertBefore('.hydroviv-auto-ship-new .auto-ship-outer-wrapper .right-block');
                $('.hydroviv-auto-ship-new .auto-ship-outer-wrapper .left-block').css('opacity',1);                              
                autoShipFlag = true;
            }        
        }
    }    
}

/* Document Ready */
$(document).ready(function() {

  

   setTimeout(function() { 
       equalHeights();
      autoShipSlider();
    }, 500);

  
    
    
    	
	$("a[href='#']").click(function(e) {
		e.preventDefault();
		
	});
    
    
    
	
	$("a[href^='#']").click(function(e) {
		
		
		e.preventDefault();
		
		
			$('.our-analysis-wrapper .analysis-outer-block').slideDown(10);
            $('.our-analysis-wrapper .analysis-click').addClass('analysis-open');
            $('.click-desc').text("CLICK TO CLOSE");

		
		
			if ($(e.target.hash).length){
		
				console.log($(e.target.hash));
			
						$(document).delay( 200 ).scrollTop( $(e.target.hash).offset().top );
}
		
		
	});

	/*our analysis section*/
	$('.our-analysis-wrapper .analysis-click .arrow-icon').click(function(){
        if($('.our-analysis-wrapper .analysis-click').hasClass('analysis-open')) {
            $('.our-analysis-wrapper .analysis-outer-block').slideUp();
            $('.our-analysis-wrapper .analysis-click').removeClass('analysis-open');
            $('.click-desc').text("CLICK TO LEARN");
        }else {
            $('.our-analysis-wrapper .analysis-outer-block').slideDown();
            $('.our-analysis-wrapper .analysis-click').addClass('analysis-open');
            $('.click-desc').text("CLICK TO CLOSE");
        }
    });

      // accordion js
    jQuery('.accordian-heading-block').click(function(){
        jQuery(this).closest('.accordian-wrapper').toggleClass('expanded');
        jQuery(this).closest('.accordian-wrapper').find('.accordian-content-block').slideToggle();
    });

  
})

jQuery(window).resize(function() {
	equalHeights();
      autoShipSlider();
});
	